import { SfSelectOption } from 'ngx-smart-form';
import { IntermediarioEnum } from '../models/intermediario.enum';

export const INTERMEDIARIO_OPTIONS: Readonly<SfSelectOption>[] = [
  { view: 'Poste italiane S.p.a.', value: IntermediarioEnum.POSTE_ITALIANE },
  {
    view: 'Cassa depositi e prestiti S.p.a.',
    value: IntermediarioEnum.CASSA_DEPOSITI,
  },
  {
    view: 'pubblica amministrazione',
    value: IntermediarioEnum.PUBBLICA_AMMINISTRAZIONE,
  },
  {
    view: "istituzione o organismo che svolge funzioni pubbliche, conformemente al diritto dell'Unione Europea",
    value: IntermediarioEnum.ISTITUZIONE_ORGANISMO,
  },
  { view: 'banca', value: IntermediarioEnum.BANCA },
  {
    view: 'istituto di moneta elettronica (IMEL)',
    value: IntermediarioEnum.IMEL,
  },
  { view: 'istituto di pagamento (IP)', value: IntermediarioEnum.IP },
  {
    view: 'società di intermediazione mobiliare (SIM)',
    value: IntermediarioEnum.SIM,
  },
  {
    view: 'società di gestione del risparmio (SGR)',
    value: IntermediarioEnum.SGR,
  },
  {
    view: 'società di investimento a capitale variabile (SICAV)',
    value: IntermediarioEnum.SICAV,
  },
  {
    view: 'società di investimento a capitale fisso, mobiliare e immobiliare (SICAF)',
    value: IntermediarioEnum.SICAF,
  },
  {
    view: "intermediario iscritto nell'albo previsto dall'articolo 106 TUB",
    value: IntermediarioEnum.TUB_106,
  },
  {
    view: 'impresa di assicurazione',
    value: IntermediarioEnum.IMPRESA_ASSICURAZIONE,
  },
  {
    view: "soggetto erogante micro-credito, ai sensi dell'articolo 111 TUB",
    value: IntermediarioEnum.TUB_111,
  },
  {
    view: "confidi o altro soggetto di cui all'articolo 112 TUB",
    value: IntermediarioEnum.TUB_112,
  },
  {
    view: 'intermediario bancario o finanziario estero',
    value: IntermediarioEnum.INTERMEDIARIO_ESTERO,
  },
  {
    view: 'succursale insediata di intermediario bancario o finanziario estero',
    value: IntermediarioEnum.SUCCURSALE_INTERMEDIARIO,
  },
  { view: 'nessuno dei precedenti', value: IntermediarioEnum.NESSUNO },
];
